import axios from 'api/axiosInstances/axiosInstance';

export const updateUserDefaultCreditCard = (billingAccount) => {
  return axios.put(`/users/creditcards/${billingAccount}`, { isdefault: true });
};
